








import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";
import { ImageHelper } from '@/helper/imageHelper';

import PullDown from "./resources/pullDown.vue";

@Component({
  components: {
    PullDown
  }
})
export default class ColorSelector extends Vue {
    @Prop() private bgColor!: string;

    click(){
        this.$emit("click")
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
